import styled from 'styled-components';
import { ButtonCustomTransparent } from '../../components/ButtonCustom';

export const Container = styled.div`
  /* Branco é o padrão da página: só as faixas verdes se declaram. Antes era o
     inverso, e cada faixa clara precisava repetir a cor -- qualquer seção nova
     nascia verde por descuido. */
  background: var(--white-color);
  max-width: 100%;
  position: relative;
  overflow: hidden;

  h2 {
    position: relative;
    margin: 4.375rem auto 2.75rem;
    text-align: center;
    font-size: clamp(1.5rem, 2.5vw + 1rem, 2.25rem);
    color: var(--first-color);
    width: fit-content;

    @media only screen and (max-width: 750px) {
      margin: 2.5rem auto 1.5rem;
    }

    &::after {
      content: '';
      display: block;
      width: 3.75rem;
      height: 0.25rem;
      margin: 0.75rem auto 0;
      border-radius: 0.25rem;
      background: var(--sixth-color);
    }
  }
  .banner {
    /* A altura do banner é definida aqui, num lugar só: a proporção fica na
       caixa externa e tudo do slick estica para 100% dela. Antes o slider
       ficava mais alto que a imagem (margem do tema, caixa dos dots, etc.) e
       essa sobra aparecia como uma tira do fundo do Container abaixo do banner.
       O overflow: hidden garante que nada volte a sobrar. */
    position: relative;
    height: 36vw; /* fallback para navegador sem aspect-ratio */
    aspect-ratio: 100 / 36;
    overflow: hidden;

    @supports (aspect-ratio: 1) {
      height: auto;
    }

    .slick-slider,
    .slick-list,
    .slick-track,
    .slick-slide > div {
      height: 100%;
    }

    /* Dots presos à base da imagem, sem depender da altura do slider. */
    .slick-dots {
      bottom: 1.5rem !important;
      transform: none !important;
      /* A ul do slick ocupa 100% da largura: é uma tira invisível atravessando
         o banner na altura dos dots. Em tela grande o card desce e o botão
         "leia mais" cai bem embaixo dessa tira, que engolia o clique -- o
         cursor virava mãozinha e nada acontecia. O clique passa direto pela
         tira e só os dots continuam clicáveis. */
      pointer-events: none;
    }

    .slick-dots li {
      pointer-events: auto;
    }

    .slick-slider {
      .slick-next {
        margin-right: 3.125rem !important;
      }
      .slick-prev {
        margin-left: 3.125rem;
      }
    }
    /* Círculo verde com a seta branca dentro, do mesmo desenho do botão de
       voltar ao topo do rodapé. O react-slick clona o ícone do MUI e põe nele a
       classe .slick-prev/.slick-next, então quem recebe o círculo é o próprio
       svg -- daí background e border-radius aqui, e não num invólucro.
       Fica dentro de .slick-slider de propósito: o RotatingBanner é compartilhado
       com outras páginas e traz regras próprias para essas classes; o seletor
       mais específico garante que este visual valha só no banner da home. */
    .slick-slider {
      .slick-prev,
      .slick-next {
        box-sizing: border-box;
        width: 3.5rem;
        height: 3.5rem;
        padding: 0.9rem;
        border-radius: 50%;
        /* Preto translúcido, não verde: o fundo do slide é arte livre e um dia
           vem verde -- e aí um círculo verde some dentro dele. Escuro com a
           seta branca é o único par que se sustenta sobre qualquer arte, clara
           ou escura, e é o mesmo recurso do card de texto logo abaixo. */
        background: rgba(0, 0, 0, 0.35);
        backdrop-filter: blur(2px);
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        transition: background-color 0.2s ease;

        /* O glyph de texto que o slick-theme desenha por baixo. */
        &::before {
          content: none;
        }

        path {
          fill: var(--white-color);
          /* A sombra existia para a seta se destacar solta sobre a foto; sobre
             o círculo ela só suja o traço. */
          filter: none;
        }

        /* Os dois ícones do MUI não são centrados no próprio quadro de 24: o de
           voltar ocupa de 0 a 11.67, então o centro dele cai em 5.8 e precisa
           dos ~6.2 que faltam. O de avançar vai de 6.23 a 18, centro 12.1, já
           nasce centrado -- o translateX(2px) que havia nele era para o desenho
           antigo, solto sobre a foto. */
        &.slick-prev path {
          transform: translateX(6.2px);
        }

        &.slick-next path {
          transform: none;
        }

        /* No hover fecha a transparência, em vez de trocar de cor: é a mesma
           peça ficando mais firme, e não outra cor entrando. */
        &:hover,
        &:focus-visible {
          background: rgba(0, 0, 0, 0.55);
        }
      }
    }

  }
  .slick-dots li {
  width: 20px;
  height: 4px;
  background: white; /* Indicadores brancos */
  border-radius: 2px; /* Deixa as pontas arredondadas */
  margin: 0 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);
}


.slick-dots li.slick-active {
  background: rgb(10, 152, 57); /* Cor do indicador ativo */
}
.slick-dots li button:before {
  opacity: 0;
  visibility: hidden;
}


  /* Até 50rem some a seta inteira, não só o traço de dentro: escondendo só o
     path sobrava o círculo verde vazio por cima da arte. */
  .slick-prev,
  .slick-next {
    display: none;

    @media only screen and (min-width: 50rem) {
      display: block;
    }
  }
`;


export const BannerBox = styled.div`
  box-sizing: border-box;
  background-image: url(${(props) => props.img});
  background-repeat: no-repeat;
  background-size: cover;
  display: flex !important;
  /* Ancorado embaixo, que é onde o card sempre esteve. Antes chegava lá por
     uma margem de topo em % com a altura do card chutada dentro da conta, e
     era ela que o estourava pela base em tela grande. Preso pelo pé, texto
     maior cresce para cima, onde há espaço sobrando. */
  align-items: flex-end;
  justify-content: flex-start;
  gap: 10%;
  padding: 3% 2%;
  /* A proporção agora é do .banner (Container), e o slide só preenche: assim a
     altura não depende de vw -- o .App é limitado a 2000px, então acima disso,
     ou com zoom out, o "height: 36vw" crescia sem a largura acompanhar e o
     cover recortava a imagem. */
  height: 100%;
  img {
    max-width: 15rem;
    transform: rotate(20deg);
    width: 32%;
  }
`;

export const ContentBanner = styled.div`
  color: var(--white-color);
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  opacity: 0.9;
  /* Distância da borda esquerda e do pé do slide -- os mesmos 12% e 5% de
     antes. A posição vertical agora é do align-items do BannerBox. */
  margin: 0 0 5% 12%;
  flex-direction: column;
  width: 50%;
  /* Tudo do card mede em vw, então ele encolhe junto com o banner, que também
     tem a altura presa à largura (proporção 100/36). É isso que o faz caber em
     qualquer tela sem rolagem e sem corte. */
  max-width: clamp(11rem, 22vw, 24rem);
  font-size: clamp(0.7rem, 0.85vw, 1rem);
  border-radius: 0.875rem;
  padding: 1vw;
  background: linear-gradient(135deg, rgba(15, 78, 43, 0.82) 0%, rgba(0, 137, 58, 0.55) 100%);
  backdrop-filter: blur(3px);
  box-shadow: 0 0.625rem 1.875rem -0.625rem rgba(0, 0, 0, 0.45);

  visibility: hidden; /* Esconde por padrão */

  /* Mostra apenas se houver conteúdo dentro */
  &:has(h2:not(:empty), span:not(:empty)) {
    visibility: visible;
  }

  @media only screen and (min-width: 50rem) {
    text-align: justify;
  }

  @media only screen and (max-width: 750px) {
    display: none;
  }
  h2 {
    color: var(--white-color);
    text-align: left;
    margin: 0;
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
    font-size: clamp(0.95rem, 1.35vw, 1.5rem);
  }
  span {
    margin: 0 0 0.5rem;
    @media only screen and (min-width: 50rem) {
      /* Em vw pelo mesmo motivo da fonte: era 1.875rem fixo, e num banner mais
         baixo esse respiro sozinho já empurrava o botão para fora. */
      margin: clamp(0.75rem, 1.6vw, 1.875rem) 0 clamp(0.6rem, 1.3vw, 1.5rem);
      text-align: justify;
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
    }
  } 
`;

export const ReadMoreButton = styled(ButtonCustomTransparent)`
  color: var(--white-color);
  border-color: var(--white-color);
  max-width: 11.938rem;
  min-width: 6.25rem;
  font-size: 0.813rem;
  transition: all 0.15s ease-in-out; /* Transição suave */

  @media only screen and (min-width: 50rem) {
    /* Fluido junto com o card: de padding e fonte fixos, ele virava o pedaço
       mais alto do card justamente onde havia menos espaço. */
    padding: clamp(0.35rem, 0.55vw, 0.625rem) clamp(1.25rem, 2.8vw, 3.125rem);
    font-size: clamp(0.7rem, 0.85vw, 1rem);
    box-shadow: 0 4px 6px rgba(0.2, 0, 0, 0.2);

    &:hover {
      transform: scale(1.05); /* Aumenta ligeiramente */
      box-shadow: 0 6px 10px rgba(221, 213, 213, 0.3); /* Sombra mais intensa */
    }
  }
`;

/* A cor de destaque vem da paleta do bloco (ACESSO_SPANS/ACESSO_CORES na Home)
   e, fora dela, do campo `cor` do cartão no Squidex. Vários desses valores são
   claros demais para texto sobre branco (#8fc684, #f0b733, #c7d300 reprovam em
   contraste), então o texto usa a mesma cor escurecida via color-mix -- a
   primeira declaração fica como fallback em navegador sem suporte. Quando nem
   isso basta, o tile manda um tom próprio para o texto. */
const accentText = ({ $color }) => `
  color: ${$color || 'var(--second-color)'};
  color: color-mix(in srgb, ${$color || 'var(--second-color)'} 75%, #0b2f1c);
`;

/* ----------------------------------------------- o ritmo da página
   Duas peças, e só elas: Faixa dá o ritmo vertical e o fundo; Interior dá a
   largura. Antes cada seção tinha o próprio padding e o próprio invólucro --
   três invólucros byte a byte idênticos e quatro seções quase iguais --, e
   acertar o espaço de uma não acertava o das outras. Era isso que fazia de
   cada ajuste um ajuste manual em quatro lugares.
   Mudar o respiro do site inteiro agora é mudar RESPIRO. */
const RESPIRO = '5rem';
/* Para faixa com decoração no topo: o desenho ocupa parte do espaço, então o
   respiro cheio sobra. */
const RESPIRO_TOPO_CURTO = '2.5rem';
const RESPIRO_ESTREITO = '4rem';
/* Altura do traço amarelo da faixa do app. É constante porque duas peças
   dependem dela: o próprio traço e o quanto o conteúdo desce para começar
   embaixo dele. */
const TRACO_APP = '10.625rem';
const TRACO_APP_ESTREITO = '6rem';
const LADO = '1.5rem';
const LADO_ESTREITO = '1.25rem';

/* O véu claro das faixas com arte de fundo. Fica aqui, e não em cada faixa,
   porque é decisão de identidade: a arte entra como textura sob o verde claro
   da casa. As opacidades vieram do contraste do texto escuro sobre a parte
   mais escura da foto -- o parágrafo fica em 4.70:1 com o véu a 83%. */
const VEU = 'linear-gradient(100deg, rgba(221, 234, 226, 0.87) 0%, rgba(221, 234, 226, 0.83) 45%, rgba(221, 234, 226, 0.88) 100%)';

const semLado = 'padding-left: 0; padding-right: 0;';

export const Faixa = styled.section`
  /* Âncora para decoração posicionada dentro da faixa (o traço amarelo do app).
     Sem isso o absolute sobe até o Container e a decoração vai para o topo da
     página. */
  position: relative;
  box-sizing: border-box;
  padding: ${RESPIRO} ${LADO};
  background-color: ${({ $verde }) => ($verde ? '#DDEAE2' : 'transparent')};

  /* Conteúdo de ponta a ponta, para faixa cuja arte é o fundo. */
  ${({ $sangra }) => ($sangra ? semLado : '')}

  /* Respiro de topo curto: ver RESPIRO_TOPO_CURTO. */
  ${({ $topoCurto }) => ($topoCurto ? `padding-top: ${RESPIRO_TOPO_CURTO};` : '')}

  /* A arte entra como fundo da FAIXA, não do bloco de dentro. É o que mantém
     o respiro dentro da imagem: com a imagem no bloco, ela virava uma tira
     curta atravessando o vazio da faixa. */
  ${({ $imagem, $veu = true }) => ($imagem ? `
    background-image: ${$veu ? `${VEU},` : ''} url(${$imagem});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  ` : '')}

  @media only screen and (max-width: 750px) {
    padding: ${RESPIRO_ESTREITO} ${LADO_ESTREITO};
    ${({ $sangra }) => ($sangra ? semLado : '')}
  }
`;

export const Interior = styled.div`
  margin: 0 auto;
  max-width: 67.75rem;

  @media only screen and (min-width: 100rem) {
    max-width: 90.33rem;
  }
`;

/* Bloco "Acesso rápido": bento de 4 colunas alimentado por inicio.cartoes do
   Squidex, com tiles de 1 ou 2 colunas e cada cartão na sua cor. */
export const Reveal = styled.div`
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? '0' : '1.25rem')});
  transition: opacity 0.6s ease, transform 0.6s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const AccessHead = styled.div`
  max-width: 40rem;
  margin-bottom: 2.25rem;

  /* O h2 do Container é centralizado e tem o próprio traço; aqui ele fica à
     esquerda e o traço vem depois do parágrafo, como no protótipo. */
  h2 {
    margin: 0.5rem 0 0;
    text-align: left;
    color: #17251b;
    font-weight: 700;

    &::after {
      display: none;
    }
  }

  p {
    margin: 0.75rem 0 0;
    color: #4b554d;
    font-size: 0.875rem;
    line-height: 1.6;
  }
`;

export const AccessEyebrow = styled.span`
  display: block;
  color: var(--second-color);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const AccessRule = styled.div`
  width: 3rem;
  height: 0.1875rem;
  margin-top: 1.25rem;
  /* Âmbar, como os traços do resto do site (o h2::after do Container). */
  background: var(--sixth-color);
`;

export const Bento = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* No desktop as três linhas fecham exatas (2+1+1, 1+2+1, 2+2) e o dense não
     muda nada; em 2 colunas ele evita o buraco que um tile de 2 colunas
     deixaria ao não caber na coluna restante. */
  grid-auto-flow: dense;
  gap: 1.25rem;

  @media only screen and (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const AccessTile = styled.article`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  grid-column: span ${({ $span }) => $span || 1};
  /* Sem padding no tile: a foto encosta na borda e o respiro do texto fica no
     AccessBody. */
  padding: 0;
  background: var(--white-color);
  border: 1px solid #e4e9e3;
  border-top: 0.1875rem solid ${({ $color }) => $color || 'var(--second-color)'};
  border-radius: 0.875rem;
  text-align: left;
  transition: box-shadow 0.25s ease, transform 0.25s ease;

  @media only screen and (max-width: 600px) {
    grid-column: span 1;
  }

  &:hover {
    box-shadow: 0 0.5rem 1.25rem rgba(15, 78, 43, 0.12);
    transform: translateY(-0.25rem);
  }

  h3 {
    margin: 0;
    color: #1b2a20;
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.35;
  }

  p {
    margin: 0.625rem 0 0;
    color: #4b554d;
    font-size: 0.875rem;
    line-height: 1.6;
    text-align: left;
  }
`;

export const AccessBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1.25rem;
`;

/* Foto do cartão (campo `imagem` no Squidex), quando houver. O arredondamento
   é da própria imagem, e não overflow: hidden no tile -- no tile o clipping
   arredondado quebra junto com o transform do hover. */
export const AccessMedia = styled.img`
  display: block;
  width: 100%;
  aspect-ratio: 3 / 2;
  object-fit: cover;
  border-radius: 0.6875rem 0.6875rem 0 0;
  background: #eef0ec;
`;

export const AccessLink = styled.button`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 0.375rem;
  margin-top: auto;
  padding-top: 1.25rem;
  font-size: 0.875rem;
  font-weight: 600;
  ${accentText}

  .arrow-icon {
    transition: transform 0.25s ease;
  }

  &:hover .arrow-icon {
    transform: translateX(0.1875rem);
  }
`;


/* ------------------------------------------- faixa do app ("um elo")
   Refeita sem as duas artes de fundo: o título era texto dentro de um PNG
   sobre um segundo PNG desfocado. Agora o título é texto de verdade, a faixa
   é branca como as outras claras, e a única imagem é a mão com o celular.
   O traço amarelo é SVG no código, não imagem: assim ele acompanha a largura
   da tela sem esticar nem pesar. Se um dia precisar variar por página, aí sim
   vale um campo. */
export const AppBox = styled.div`
  position: relative;
  display: grid;
  /* Metade da largura para cada um. Eram colunas "auto", que davam a cada
     lado o tamanho do próprio conteúdo -- então trocar a arte por uma mais
     larga ou mais estreita mexia no lugar do texto. */
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: clamp(1.5rem, 3vw, 3.5rem);
  align-items: end;
  margin: 0 auto;
  max-width: 67.75rem;
  /* Texto e foto começam abaixo do traço amarelo. A conta sai da altura do
     traço menos o respiro que a faixa já dá no topo, mais 1rem de folga --
     assim ela se acerta sozinha se um dos dois valores mudar. */
  padding-top: calc(${TRACO_APP} - ${RESPIRO_TOPO_CURTO} + 1rem);

  @media only screen and (min-width: 100rem) {
    max-width: 90.33rem;
  }

  /* Empilha antes de o título de 4.5rem e a foto começarem a se apertar. */
  @media only screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    align-items: start;
    justify-items: center;
    gap: 2rem;
  }

  /* No estreito o traço é mais baixo e a faixa dá respiro cheio: a mesma conta,
     com as medidas de lá. */
  @media only screen and (max-width: 750px) {
    padding-top: calc(${TRACO_APP_ESTREITO} - ${RESPIRO_ESTREITO} + 1rem);
  }
`;

/* O traço amarelo atravessa a faixa inteira, por cima do conteúdo mas sem
   capturar clique. Fica fora do AppBox para não ser limitado pela largura
   máxima dele. */
export const AppTraco = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${TRACO_APP};
  display: block;
  pointer-events: none;

  path {
    fill: none;
    stroke: var(--sixth-color);
    stroke-width: 3;
  }

  @media only screen and (max-width: 750px) {
    height: ${TRACO_APP_ESTREITO};
  }
`;

export const AppTexto = styled.div`
  display: flex;
  flex-direction: column;
  /* 1.25rem: com o título em 5.5rem, 1.5rem entre título, texto e botão abria
     demais e o bloco perdia unidade. */
  gap: 1.25rem;
  padding-bottom: clamp(1rem, 4vw, 3rem);

  h2 {
    margin: 0;
    max-width: 8ch;
    text-align: left;
    color: var(--second-color);
    font-size: clamp(2.75rem, 6.5vw, 6.5rem);
    font-weight: 800;
    line-height: 0.95;
    letter-spacing: -0.02em;
    /* CAIXA ALTA no CSS e não no conteúdo: quem escreve digita normal, e o
       texto continua legível no Squidex e para leitor de tela. */
    text-transform: uppercase;

    &::after {
      display: none;
    }
  }

  p {
    margin: 0;
    max-width: 42ch;
    color: #4b554d;
    font-size: 1.25rem;
    line-height: 1.65;
  }

  strong {
    color: #17251b;
    font-weight: 700;
  }

  @media only screen and (max-width: 900px) {
    padding-bottom: 0;
    /* Empilhado o bloco fica centralizado junto com a foto: alinhado à
       esquerda, com a arte centrada embaixo, os dois pareciam desencontrados. */
    align-items: center;
    text-align: center;

    h2 {
      text-align: center;
    }

    button {
      align-self: center;
    }
  }
`;

/* Pílula verde com o selo do play. O texto branco sobre o --second-color dá
   4.53:1, que passa o mínimo de 4.5 -- por pouco, então não clarear o verde
   daqui sem medir de novo. */
export const AppBotao = styled.button`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 0.75rem;
  min-height: 2.75rem;
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
  border: 0;
  border-radius: 999px;
  background: var(--second-color);
  color: var(--white-color);
  cursor: pointer;
  font-family: inherit;
  font-size: 0.9375rem;
  font-weight: 600;
  transition: background-color 0.2s ease;

  &:hover {
    background: var(--first-color);
  }

  .selo {
    display: grid;
    place-items: center;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.18);
    flex: none;
  }
`;

export const AppImagem = styled.img`
  align-self: end;
  /* Encostada no começo da própria metade, ou seja, no lado do texto. A partir
     de 100rem a caixa vai a 90.33rem e a coluna fica mais larga que o teto da
     arte: centrada, essa folga toda virava distância entre os dois. */
  justify-self: start;
  width: 100%;
  max-width: 35rem;
  /* Do tamanho do bloco de texto ao lado. Era clamp(28rem, 55vw, 52rem), altura
     de quando a arte tinha o braço e precisava sangrar até a base da faixa. */
  height: clamp(25rem, 42vw, 38rem);
  /* contain e não cover: a arte vem recortada e sem fundo -- cortar nas bordas
     comeria o aparelho. Como a caixa tem altura fixa e a imagem só se encaixa
     dentro dela, qualquer arquivo que venha do Squidex cabe sem mexer no
     layout. */
  object-fit: contain;
  object-position: center bottom;

  /* Empilhado não há lado do texto para encostar: volta ao centro, junto com o
     justify-items do AppBox. */
  @media only screen and (max-width: 900px) {
    justify-self: center;
  }

  @media only screen and (max-width: 750px) {
    height: clamp(19rem, 60vw, 27rem);
  }
`;

export const VideoBoxPlay = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;
  gap: 15px;

  /* Precisa de largura própria: é ela que define o containing block do .mold.
     Sem isso o .mold com largura percentual encolhe até o tamanho do botão. */
  width: 750px;
  max-width: 100%;

  @media screen and (max-width: 750px) {
    min-height: 0;
    border-radius: 1rem;
  }

  @media screen and (max-width: 900px) {
    width: 350px;
  }
`

export const VideoBannerBox = styled.div`
  /* Duas colunas lado a lado, separadas só pelo gap: o par fica centralizado
     na faixa (antes o flex com justify-content: flex-end encostava os dois na
     direita; com space-between eles se afastavam demais). */
  display: grid;
  grid-template-columns: minmax(0, 750px) minmax(0, 500px);
  justify-content: center;
  /* center e não start: com o bloco alto, "start" grudaria o par no topo e
     deixaria o vazio embaixo -- o mesmo defeito, só movido de lugar. */
  align-items: center;
  align-content: center;
  /* Altura em rem e não em vh: as outras faixas agora têm a altura do próprio
     conteúdo, e 40rem deixa esta parecida com elas em qualquer tela. */
  /* 34rem e não 44rem: os 10rem de respiro agora vêm da Faixa em volta. */
  min-height: 34rem;
  position: relative;
  /* Sem margem vertical: quem dá o respiro agora é a Faixa em volta.
     Antes eram 6rem daqui, e somados ao padding da seção o vazio dobrava. */
  margin: 0;
  padding: 0 1.5rem;

  gap: 70px;

  .mold {
      position: relative;
      /* Fluido com teto de 750px: entre 1453px e ~1520px a coluna fica menor
         que 750px e a largura fixa vazava para fora dela. A proporção 25/12 é
         exatamente os 750x360 de antes. */
      width: 100%;
      max-width: 750px;
      aspect-ratio: 25 / 12;
      border: 4px solid var(--white-color);
      border-radius: 50px;
      box-shadow: 0 10px 30px rgba(0,0,0,0.35), 0 0 0 6px rgba(199, 211, 0, 0.18);
      overflow: hidden;
  }

  /* Abaixo de 1452px o vídeo (750px) + o texto (500px) + gap + padding deixam
     de caber lado a lado — a partir daqui empilha, em vez de espremer o texto
     até ele vazar para fora da tela. */
  @media screen and (max-width: 1452px) {
    /* Uma coluna só: o texto passa para baixo do vídeo. */
    grid-template-columns: minmax(0, 1fr);
    justify-items: center;
    padding: clamp(4rem, 5vw, 5rem) 1.25rem;
    gap: clamp(1.5rem, 3vw, 70px);
    /* Sem margem: quem enquadra o bloco é a Faixa em volta. */
    margin: 0;
    /* Empilhado o conteúdo já é mais alto que 40rem: o mínimo só criaria
       vazio embaixo. */
    min-height: 0;
  }

  .mold::before {
      z-index: 2;
      content: '';
      position: absolute;
      top: 50%;
      left: 0%;
      transform: translate(-50%, -50%);
      width: 30px;
      height: 200px;
      background: var(--white-color);
      border-radius: 0px 20px 20px 0px;
  }

  @media screen and (max-width: 900px) {
    .mold {
      width : 100%;
      height: auto;
      aspect-ratio: 7 / 12;
      border: 5px solid  var(--white-color);
      border-radius: 25px;
    }

    .mold::before {
      content: '';
      position: absolute;
      top: 0%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 200px;
      height: 30px;
      background: var(--white-color);
      border-radius: 0px 0px 20px 20px;
  }
  }
`;


export const ButtonController = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 15px;
  width: 100%;

  button {
    font-weight: 600;
    width: 170px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--second-color);
    color: #fff;
    border-radius: 45px;
    padding: 10px;
    gap: 8px;
    box-shadow: 0 0.375rem 0.75rem -0.375rem rgba(0, 0, 0, 0.4);
    transition: background-color 0.2s ease, transform 0.2s ease;
  }

  button:hover {
    background: var(--first-color);
    transform: translateY(-0.125rem);
  }

  button .icon {
    width: 17px;
    height: 17px;
    font-weight: 100;
 
  }

  @media screen and (max-width: 760px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }


`

export const VideoPhoneBoxMold = styled.div`
  background: url(${props => props.src}) no-repeat center center;
  background-size: cover;
  display:flex;
  opacity: 0.9;
  justify-content: center;
  align-items: center;

  button {
    color: var(--sixth-color);
    background: rgba(255, 255, 255, 0.85);
    clip-path: circle();
    cursor: pointer;
    box-shadow: 0 0.5rem 1.25rem rgba(0, 0, 0, 0.3);
    transition: transform 0.2s ease, background-color 0.2s ease;
  }

  button:hover {
    transform: scale(1.08);
    background: var(--white-color);
  }

  button .icon {
    /* chega aos 60px originais no desktop e reduz junto com a moldura */
    width: clamp(2.5rem, 4vw, 60px);
    height: clamp(2.5rem, 4vw, 60px);
    font-weight: 100;
  }
`


export const VideoBannerContent = styled.div`
  max-width: 500px;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  /* As mesmas cores das outras seções da Home. */
  color: #17251b;
  gap: 10px;

  /* Kicker em texto puro, sem a pílula verde. */
  span {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    /* O verde mais claro que ainda passa aqui. O --second-color das outras
       seções dá 2.84:1 sobre esta faixa e reprova o mínimo de 4.5 -- e o teto
       dele aqui é 3.65 (véu a 100%, sem imagem nenhuma), pior que o 3.65 do
       chapéu do Acesso rápido. Medi a escala: #007a33 dá 3.44, #00702e dá 3.92,
       e #006129 dá 4.80. Este é o mais claro que passa. */
    color: #006129;
  }

  h2 {
    font-size: var(--fs-h1);
    color: #134721ff;
    text-align: start;
    margin: 0 !important;
  }

  p {
    font-size: var(--fs-body);
    text-align: justify;
    color: #4b554d;
  }

  /* Empilhado (≤1452px): acompanha a largura do vídeo */
  @media screen and (max-width: 1452px) {
    max-width: min(750px, 100%);
  }

  /* Mobile (≤600px): centralizado */
  @media screen and (max-width: 37.5rem) {
    align-items: center;
    text-align: center;

    h2 {
      text-align: center;
    }

    p {
      text-align: center;
    }
  }
`;


export const VideoBox = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  overflow: hidden;
  position: relative;
  cursor: pointer;

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
  }
`;


export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.div`
  position: relative;
  width: 80vw;
  height: 45vw; 
  max-width: 960px;
  max-height: 540px;
  background: black;
  border-radius: 12px;
  overflow: visible;
  box-shadow: 0 0 20px #000;
  border-top: 5px solid var(--first-color);

  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.5);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const CloseButton = styled.button`
  border: none;
  color: white;
  font-size: 36px;
  padding: 0px 10px;
  background: var(--first-color);
  cursor: pointer;
  z-index: 10;
  transition: .3s;

  &:hover {
    background: var(--second-color);
  }
`;

export const ButtonsController = styled.div`
   position: absolute;
  top: -44px;
  right: 8px;
  background: transparent;
`
export const BizHead = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 2.5rem;
  /* 1.25rem e não 2.25rem: o traço âmbar acima ocupa ~1rem, e a seção não
     deve crescer por causa dele. */
  margin-bottom: 1.25rem;

  h2 {
    margin: 0.5rem 0 0;
    max-width: 34rem;
    text-align: left;
    color: #17251b;
    font-weight: 700;

    /* O mesmo traço âmbar das outras faixas -- era o único cabeçalho sem ele.
       Alinhado à esquerda, no início do texto, e não centralizado como o
       ::after do Container. */
    &::after {
      width: 3rem;
      height: 0.1875rem;
      margin: 0.875rem 0 0;
      background: var(--sixth-color);
    }
  }

  @media only screen and (max-width: 750px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const BizAllLink = styled.button`
  flex: none;
  padding: 0;
  border: 0;
  background: none;
  color: var(--second-color);
  cursor: pointer;
  font-size: 0.9375rem;
  font-weight: 600;
  white-space: nowrap;

  .arrow-icon {
    margin-left: 0.375rem;
    vertical-align: -0.15em;
    transition: transform 0.2s ease;
  }

  &:hover .arrow-icon {
    transform: translateX(0.25rem);
  }

  @media (prefers-reduced-motion: reduce) {
    .arrow-icon {
      transition: none;
    }
  }
`;

export const BizPanel = styled.div`
  display: grid;
  /* 18rem em vez de 21.25rem: o nome mais longo é "Assistência Técnica" e cabe
     folgado, e cada rem que sai daqui entra na largura da foto. */
  grid-template-columns: 18rem 1fr;

  /* Altura fixa. Sem isso quem manda na altura é o texto do item aberto, e o
     painel crescia e encolhia a cada troca de aba -- as descrições têm de duas
     a quatro linhas e a UIPS ainda não tem botão.
     É min-height e não height: texto mais longo que isso empurra o painel em
     vez de ser cortado. Crescer é feio; sumir texto é defeito. */
  min-height: 25rem;
  overflow: hidden;
  border: 1px solid #cddbd2;
  border-radius: 0.75rem;
  background: var(--white-color);

  @media only screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    /* Aqui as abas viram fileira no topo e o painel já é alto por natureza:
       o piso de 25rem só criaria vazio. */
    min-height: 0;
  }
`;

export const BizTabs = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e4ebe6;
  background: #f6faf7;

  @media only screen and (max-width: 900px) {
    flex-direction: row;
    border-right: 0;
    border-bottom: 1px solid #e4ebe6;
    overflow-x: auto;
    /* A fileira rola: o indicador nativo aparece só no toque, e sem isso a
       oitava aba fica escondida sem nenhum sinal. */
    scrollbar-width: thin;
  }
`;

export const BizTab = styled.button`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  /* 2.75rem e não 3.25rem: são oito abas, e cada 8px a mais aqui empurra 64px
     na altura do painel -- que é a altura que a moldura da foto tem que
     preencher. Nome de frente é sempre uma linha, então 44px sobra. */
  min-height: 2.75rem;
  padding: 0.75rem 1.25rem;
  border: 0;
  border-bottom: 1px solid #e4ebe6;
  background: ${({ $ativo }) => ($ativo ? 'var(--white-color)' : 'transparent')};
  color: ${({ $ativo }) => ($ativo ? 'var(--second-color)' : '#17251b')};
  cursor: pointer;
  font-family: inherit;
  font-size: 0.9375rem;
  font-weight: 600;
  text-align: left;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    color: var(--second-color);
  }

  /* O traço que marca o item ativo. Fica como elemento e não como border para
     não empurrar o texto ao entrar e sair. */
  &::before {
    content: '';
    flex: none;
    width: 0.1875rem;
    height: 1.125rem;
    border-radius: 0.125rem;
    background: ${({ $ativo }) => ($ativo ? 'var(--second-color)' : 'transparent')};
  }

  @media only screen and (max-width: 900px) {
    flex: none;
    min-height: 2.75rem;
    border-bottom: 0;
    white-space: nowrap;

    &::before {
      display: none;
    }

    /* Na horizontal o ativo é marcado por baixo, onde o olho procura numa
       fileira de abas. */
    box-shadow: ${({ $ativo }) => ($ativo ? 'inset 0 -0.1875rem 0 var(--second-color)' : 'none')};
  }
`;

export const BizBody = styled.div`
  display: grid;
  /* Sem foto o painel ocupa a largura toda, em vez de deixar um terço vazio. */
  /* Meio a meio quando tem foto. A foto preenche a coluna inteira, então quanto
     mais larga a coluna, menos em pé fica o slot e menos a imagem é cortada --
     em 1.2/0.8 aparecia 60% da largura da foto, em 1/1 aparece 75%. O texto
     fica com ~400px, que ainda é confortável para a manchete. */
  grid-template-columns: ${({ $comFoto }) => ($comFoto ? 'minmax(0, 1fr) 1fr' : '1fr')};

  @media only screen and (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;


export const BizContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  padding: 2.5rem 2.375rem;

  h3 {
    margin: 0;
    color: #17251b;
    font-size: clamp(1.25rem, 1.2vw + 0.9rem, 1.6rem);
    font-weight: 700;
    line-height: 1.2;
  }

  p {
    margin: 0;
    color: #4b554d;
    font-size: 0.9375rem;
    line-height: 1.65;
  }

  @media only screen and (max-width: 750px) {
    padding: 1.75rem 1.25rem;
  }
`;

/* Sem padding: 1rem aqui empurrava o chapéu 16px para a direita do título, e
   este componente é usado nos DOIS lugares -- o cabeçalho da seção e o painel
   --, então desalinhava os dois de uma vez.
   Quem dá o respiro vertical é o gap do bloco em volta (1rem no BizContent, a
   margem do h2 no BizHead), e assim o alinhamento à esquerda fica garantido. */
export const BizEyebrow = styled.span`
  display: block;
  color: var(--second-color);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const BizLink = styled.button`
  align-self: flex-start;
  margin-top: 0.25rem;
  padding: 0;
  border: 0;
  background: none;
  color: var(--second-color);
  cursor: pointer;
  font-family: inherit;
  font-size: 0.9375rem;
  font-weight: 600;

  .arrow-icon {
    margin-left: 0.375rem;
    vertical-align: -0.15em;
    transition: transform 0.2s ease;
  }

  &:hover .arrow-icon {
    transform: translateX(0.25rem);
  }

  @media (prefers-reduced-motion: reduce) {
    .arrow-icon {
      transition: none;
    }
  }
`;

/* A foto preenche a coluna inteira, de borda a borda. O arredondamento
   acompanha o canto do painel e só do lado que encosta nele: no desktop a foto
   fica na direita, então só os dois cantos direitos.

   O painel já tem overflow: hidden, que sozinho recortaria a imagem no canto
   arredondado. O raio vai declarado aqui de todo jeito porque o recorte do pai
   falha quando algum filho ganha transform ou filter -- e o hover das setas
   nesta seção usa transform. */
export const BizMedia = styled.img`
  width: 100%;
  height: 100%;
  min-height: 100%;
  border-radius: 0 0.75rem 0.75rem 0;
  object-fit: cover;

  /* Aqui o corpo já é uma coluna só e a foto vai para baixo do texto, ainda
     dentro da coluna da direita: o canto de cima passa a ser reto. */
  @media only screen and (max-width: 1100px) {
    min-height: 15rem;
    max-height: 20rem;
    border-radius: 0 0 0.75rem 0;
  }

  /* Abaixo de 900px as abas viram uma fileira no topo e o painel é uma coluna
     só: a foto encosta nos dois cantos de baixo. */
  @media only screen and (max-width: 900px) {
    border-radius: 0 0 0.75rem 0.75rem;
  }
`;
